import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import './App.css';
import { DOMAIN, BRAND, DEFAULT_OG_IMAGE } from './seo/siteConfig';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsInteractions from './components/AnalyticsInteractions';
import Home from './pages/Home';
import MensRecovery from './pages/MensRecovery';
import WomensRecovery from './pages/WomensRecovery';
import ApplyNow from './pages/ApplyNow';
import Testimonials from './pages/Testimonials';
import Donations from './pages/Donations';
import Contact from './pages/Contact';
import Auth from './pages/Auth';
import SeoPage from './components/seo/SeoPage';
import { getPage, getAllSlugs } from './seo/registry';

// Wrapper that resolves the composed page object for a given slug
const SeoView = ({ slug }) => {
  const page = getPage(slug);
  return <SeoPage page={page} />;
};

function App() {
  const slugs = getAllSlugs();

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsInteractions />
        <Helmet>
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content={BRAND.name} />
          <meta name="description" content={BRAND.descriptor} />
          <meta property="og:title" content={BRAND.name} />
          <meta property="og:description" content={BRAND.descriptor} />
          <meta property="og:image" content={DEFAULT_OG_IMAGE} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={BRAND.name} />
          <meta name="twitter:description" content={BRAND.descriptor} />
          <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
          <link rel="canonical" href={DOMAIN + '/'} />
        </Helmet>
        <div className="App">
          <Header />
          <main className="main-content">
            <Routes>
              {/* Existing / legacy routes (preserved) */}
              <Route path="/" element={<Home />} />
              <Route path="/mens-recovery" element={<MensRecovery />} />
              <Route path="/womens-recovery" element={<WomensRecovery />} />
              <Route path="/apply" element={<ApplyNow />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/donations" element={<Donations />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/auth" element={<Auth />} />

              {/* SEO expansion routes (with and without trailing slash) */}
              {slugs.map((slug) => {
                const noSlash = slug.endsWith('/') ? slug.slice(0, -1) : slug;
                return (
                  <React.Fragment key={slug}>
                    <Route path={slug} element={<SeoView slug={slug} />} />
                    <Route path={noSlash} element={<SeoView slug={slug} />} />
                  </React.Fragment>
                );
              })}

              {/* Fallback to home for anything unmatched */}
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
